import { render, staticRenderFns } from "./UpdateSiteAttributes.vue?vue&type=template&id=79f0fab2&scoped=true"
import script from "./UpdateSiteAttributes.vue?vue&type=script&lang=js"
export * from "./UpdateSiteAttributes.vue?vue&type=script&lang=js"
import style0 from "./UpdateSiteAttributes.vue?vue&type=style&index=0&id=79f0fab2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f0fab2",
  null
  
)

export default component.exports